import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import HercaRecords from './pages/HercaRecords';
import Employees from './pages/Employees';
import Areas from './pages/Areas';
import DeviationTypes from './pages/DeviationTypes';
import Branches from './pages/Branches';
import Reports from './pages/Reports';
function App() {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  if (!token) {
    return <LoginPage onLoginSuccess={setToken} />;
  }

  return (
    <BrowserRouter>
      <Layout onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/herca" element={<HercaRecords />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/deviations" element={<DeviationTypes />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
